import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function PrivacyPolicy() {
  const content = `
    <p>share2dm(이하 "서비스")은 개인정보보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>

    <h2>제1조 (개인정보의 처리 목적)</h2>
    <p>서비스는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>

    <p><strong>1. 서비스 계정 연동 및 관리</strong></p>
    <p>Instagram 비즈니스 계정 연동, Facebook OAuth 인증, 브랜드 식별 및 서비스 제공</p>

    <p><strong>2. 자동 DM 발송 서비스 제공</strong></p>
    <p>릴스 공유 감지, 캠페인 매칭, 자동 DM 발송, 발송 이력 관리</p>

    <p><strong>3. 서비스 개선 및 통계</strong></p>
    <p>캠페인 성과 분석, 서비스 이용 통계, 서비스 품질 개선</p>

    <h2>제2조 (처리하는 개인정보의 항목)</h2>
    <p>서비스는 다음의 개인정보 항목을 처리하고 있습니다.</p>

    <p><strong>1. 브랜드(이용자) 정보</strong></p>
    <ul>
      <li>Facebook/Instagram OAuth 인증을 통해 수집: Instagram 비즈니스 계정 ID, Facebook 페이지 정보, 액세스 토큰</li>
      <li>서비스 이용 과정에서 생성: 캠페인 설정 정보, 브랜드명</li>
    </ul>

    <p><strong>2. 공유자(릴스를 DM으로 공유한 Instagram 사용자) 정보</strong></p>
    <ul>
      <li>Instagram Webhook을 통해 수집: Instagram 사용자 ID (IGSID)</li>
      <li>서비스 이용 과정에서 생성: 공유한 릴스 ID, DM 발송 이력, 트래킹 URL 클릭 기록</li>
    </ul>

    <p><strong>3. 자동으로 수집되는 정보</strong></p>
    <ul>
      <li>서비스 접속 로그, 접속 IP 정보</li>
    </ul>

    <h2>제3조 (개인정보의 처리 및 보유기간)</h2>
    <p><strong>1.</strong> 서비스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>

    <p><strong>2.</strong> 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p>
    <ul>
      <li>브랜드 계정 정보: 서비스 연동 해제 시까지</li>
      <li>액세스 토큰: 토큰 만료 시 또는 연동 해제 시까지</li>
      <li>DM 발송 이력: 캠페인 종료 후 1년</li>
      <li>트래킹 클릭 기록: 수집일로부터 1년</li>
    </ul>

    <h2>제4조 (개인정보의 제3자 제공)</h2>
    <p><strong>1.</strong> 서비스는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>

    <p><strong>2.</strong> 서비스는 자동 DM 발송을 위해 다음과 같이 외부 플랫폼을 이용합니다.</p>
    <ul>
      <li>이용 플랫폼: Meta (Instagram Graph API)</li>
      <li>이용 목적: 릴스 공유 감지 (Webhook), 자동 DM 발송</li>
      <li>이용 항목: Instagram 사용자 ID, 메시지 내용</li>
    </ul>

    <h2>제5조 (개인정보처리의 위탁)</h2>
    <p>서비스는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
    <ul>
      <li>위탁받는 자: Supabase Inc.</li>
      <li>위탁하는 업무의 내용: 데이터 저장 및 관리</li>
      <li>위탁기간: 서비스 연동 해제 시 또는 위탁계약 종료 시까지</li>
    </ul>
    <ul>
      <li>위탁받는 자: Cloudflare, Inc.</li>
      <li>위탁하는 업무의 내용: 서비스 호스팅 및 Webhook 처리</li>
      <li>위탁기간: 서비스 운영 기간</li>
    </ul>

    <h2>제6조 (정보주체의 권리·의무 및 행사방법)</h2>
    <p><strong>1.</strong> 정보주체는 서비스에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
    <ul>
      <li>가. 개인정보 열람 요구</li>
      <li>나. 오류 등이 있을 경우 정정 요구</li>
      <li>다. 삭제 요구</li>
      <li>라. 처리정지 요구</li>
    </ul>

    <p><strong>2.</strong> 제1항에 따른 권리 행사는 이메일(jaewon@share2dm.xyz)을 통하여 하실 수 있으며, 서비스는 이에 대해 지체없이 조치하겠습니다.</p>

    <h2>제7조 (개인정보의 파기)</h2>
    <p><strong>1.</strong> 서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>

    <p><strong>2.</strong> 개인정보 파기 방법은 다음과 같습니다.</p>
    <ul>
      <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없도록 영구 삭제합니다.</li>
      <li>브랜드가 서비스 연동을 해제하면 해당 브랜드의 액세스 토큰, 캠페인 데이터, DM 발송 이력을 삭제합니다.</li>
    </ul>

    <h2>제8조 (개인정보의 안전성 확보조치)</h2>
    <p>서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
    <ol>
      <li>액세스 토큰 암호화 저장</li>
      <li>HTTPS를 통한 데이터 전송 암호화</li>
      <li>Webhook 서명 검증을 통한 데이터 무결성 확인</li>
      <li>데이터베이스 접근 권한 관리</li>
    </ol>

    <h2>제9조 (개인정보 보호책임자)</h2>
    <p>서비스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
    <ul>
      <li>서비스명: share2dm</li>
      <li>이메일: jaewon@share2dm.xyz</li>
    </ul>

    <h2>제10조 (개인정보 처리방침 변경)</h2>
    <p>이 개인정보 처리방침은 2025년 2월 11일부터 적용됩니다.</p>

    <h2>제11조 (권익침해 구제방법)</h2>
    <p>정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.</p>
    <ul>
      <li>개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)</li>
      <li>개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)</li>
      <li>대검찰청: (국번없이) 1301 (www.spo.go.kr)</li>
      <li>경찰청: (국번없이) 182 (ecrm.cyber.go.kr)</li>
    </ul>

    <p><strong>부칙</strong><br>
    본 방침은 2025년 2월 11일부터 시행됩니다.</p>

    <p><strong>서비스 정보</strong><br>
    서비스명: share2dm<br>
    웹사이트: https://share2dm.xyz<br>
    이메일: jaewon@share2dm.xyz</p>
  `;

  return (
    <TermsTemplate
      title="개인정보 처리방침"
      content={content}
      lastUpdated="2025년 2월 11일"
    />
  );
}
